export const INVOICE_PDF_WIDTH = 700;
export var InvoiceDateRanges = /*#__PURE__*/ function(InvoiceDateRanges) {
    InvoiceDateRanges["AllUninvoiced"] = "ALL_UNINVOICED";
    InvoiceDateRanges["Last7Days"] = "LAST_7_DAYS";
    InvoiceDateRanges["Last15Days"] = "LAST_15_DAYS";
    InvoiceDateRanges["Last30Days"] = "LAST_30_DAYS";
    InvoiceDateRanges["UptoEndDate"] = "UPTO_END_DATE";
    InvoiceDateRanges["Custom"] = "CUSTOM";
    return InvoiceDateRanges;
}({});
export var InvoiceLineItemGroups = /*#__PURE__*/ function(InvoiceLineItemGroups) {
    InvoiceLineItemGroups["Project"] = "PROJECT";
    InvoiceLineItemGroups["Phase"] = "PHASE";
    InvoiceLineItemGroups["Task"] = "TASK";
    InvoiceLineItemGroups["Role"] = "ROLE";
    InvoiceLineItemGroups["TeamMember"] = "USER";
    InvoiceLineItemGroups["TimeEntries"] = "DETAILED_TIME_ENTRIES";
    InvoiceLineItemGroups["ReimbursedTo"] = "EXPENSE_REIMBURSED_TO";
    InvoiceLineItemGroups["ExpenseBudget"] = "EXPENSE_BUDGET";
    InvoiceLineItemGroups["ExpenseCategory"] = "EXPENSE_CATEGORY";
    InvoiceLineItemGroups["ExpenseReport"] = "EXPENSE_REPORT";
    InvoiceLineItemGroups["Expense"] = "EXPENSE";
    InvoiceLineItemGroups["Adhoc"] = "ADHOC";
    return InvoiceLineItemGroups;
}({});
export var InvoiceSourceType = /*#__PURE__*/ function(InvoiceSourceType) {
    InvoiceSourceType["Project"] = "PROJECT";
    return InvoiceSourceType;
}({});
export var InvoicedEntityTypes = /*#__PURE__*/ function(InvoicedEntityTypes) {
    InvoicedEntityTypes["TimeEntry"] = "TIME_ENTRY";
    InvoicedEntityTypes["SubscriptionPeriod"] = "SUBSCRIPTION_PERIOD";
    InvoicedEntityTypes["Adhoc"] = "ADHOC";
    InvoicedEntityTypes["FixedFee"] = "FIXED_FEE";
    InvoicedEntityTypes["Expense"] = "EXPENSE";
    return InvoicedEntityTypes;
}({});
export var InvoiceStatus = /*#__PURE__*/ function(InvoiceStatus) {
    InvoiceStatus["Draft"] = "DRAFT";
    InvoiceStatus["Approved"] = "APPROVED";
    InvoiceStatus["Paid"] = "PAID";
    InvoiceStatus["PartiallyPaid"] = "PARTIALLY_PAID";
    InvoiceStatus["PartiallyCredited"] = "PARTIALLY_CREDITED";
    InvoiceStatus["Credited"] = "CREDITED";
    InvoiceStatus["Voided"] = "VOIDED";
    InvoiceStatus["WriteOff"] = "WRITE_OFF";
    InvoiceStatus["Deleted"] = "DELETED";
    InvoiceStatus["InReview"] = "IN_REVIEW";
    return InvoiceStatus;
}({});
export var TabNames = /*#__PURE__*/ function(TabNames) {
    TabNames["Comments"] = "comments";
    TabNames["Approvals"] = "approvals";
    TabNames["Payments"] = "payments";
    TabNames["Fields"] = "fields";
    TabNames["Hide"] = "hide";
    return TabNames;
}({});
export var InvoiceDisabledText = /*#__PURE__*/ function(InvoiceDisabledText) {
    InvoiceDisabledText["BlankLineOrDescription"] = "BlankLineOrDescription";
    InvoiceDisabledText["BlankTaxColumn"] = "BlankTaxColumn";
    InvoiceDisabledText["ExceededProjectWiseCreditNoteLimit"] = "ExceededProjectWiseCreditNoteLimit";
    InvoiceDisabledText["InvoiceLevelTaxExceeded"] = "InvoiceLevelTaxExceeded";
    return InvoiceDisabledText;
}({});
export const LINE_SUBTOTAL_ROW = 'SubTotalRow';
export const TAX_ROW = 'TaxRow';
export const LINE_TOTAL_ROW = 'TotalRow';
export const SUBSCRIPTION_TYPE_ROW = 'SubscriptionTypeRow';
export var DueDateOptionsEnum = /*#__PURE__*/ function(DueDateOptionsEnum) {
    DueDateOptionsEnum["IssueDate"] = "issue_date";
    DueDateOptionsEnum["Days7"] = "7_days";
    DueDateOptionsEnum["Days15"] = "15_days";
    DueDateOptionsEnum["Days30"] = "30_days";
    DueDateOptionsEnum["Days45"] = "45_days";
    DueDateOptionsEnum["Days60"] = "60_days";
    DueDateOptionsEnum["Days90"] = "90_days";
    DueDateOptionsEnum["Custom"] = "custom";
    return DueDateOptionsEnum;
}({});
export var ApprovalType = /*#__PURE__*/ function(ApprovalType) {
    ApprovalType["Individual"] = "INDIVIDUAL";
    ApprovalType["ApprovalChain"] = "APPROVAL_CHAIN";
    return ApprovalType;
}({});
export var PaymentRecordType = /*#__PURE__*/ function(PaymentRecordType) {
    PaymentRecordType["Paid"] = "PAID";
    PaymentRecordType["WriteOff"] = "WRITE_OFF";
    PaymentRecordType["CreditNote"] = "CREDIT_NOTE";
    return PaymentRecordType;
}({});
export var InvoiceEmailState = /*#__PURE__*/ function(InvoiceEmailState) {
    InvoiceEmailState["Published"] = "PUBLISHED";
    InvoiceEmailState["Draft"] = "DRAFT";
    return InvoiceEmailState;
}({});
export var InvoiceOverdueDurations = /*#__PURE__*/ function(InvoiceOverdueDurations) {
    InvoiceOverdueDurations["OneToFifteen"] = "ONE_TO_FIFTEEN";
    InvoiceOverdueDurations["SixteenToThirty"] = "SIXTEEN_TO_THIRTY";
    InvoiceOverdueDurations["ThirtyOneToFortyFive"] = "THIRTYONE_TO_FORTYFIVE";
    InvoiceOverdueDurations["FortyFivePlus"] = "FORTYFIVE_PLUS";
    return InvoiceOverdueDurations;
}({});
